import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { TrendingUp, Truck, Sparkles } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const KARAT_PURITY = { '24K': 0.999, '22K': 0.916, '18K': 0.750, '14K': 0.583 };

const TopBar = () => {
  const [rate, setRate] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);

  useEffect(() => {
    const fetchRate = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/gold-rate`);
        if (data?.rate_24k) {
          setRate(data.rate_24k);
          setUpdatedAt(data.updated_at);
        }
      } catch { /* silent */ }
    };
    fetchRate();
    const id = setInterval(fetchRate, 60000); // refresh every minute
    return () => clearInterval(id);
  }, []);

  const formatTime = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleString('en-IN', { hour: '2-digit', minute: '2-digit', day: 'numeric', month: 'short' });
  };

  return (
    <div className="bg-[#2D3B26] text-[#FDFBF7] text-[10px] md:text-xs overflow-hidden" data-testid="top-bar">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-1.5 flex items-center justify-between gap-3">
        {/* Left: Live Gold Rate */}
        {rate ? (
          <div className="flex items-center gap-3 md:gap-5 overflow-x-auto scrollbar-hide" data-testid="gold-rate-ticker">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-[#C27054] animate-pulse"></span>
              <TrendingUp size={11} className="text-[#C27054]" />
              <span className="uppercase tracking-widest font-semibold text-[#E4E8DF]/70 hidden sm:inline">Today's Rate</span>
            </span>
            {Object.entries(KARAT_PURITY).map(([k, p]) => (
              <span key={k} className="whitespace-nowrap" data-testid={`ticker-${k}`}>
                <span className="font-bold text-[#C27054]">{k}</span>
                <span className="text-[#E4E8DF]/80"> ₹{Math.round(rate * p).toLocaleString('en-IN')}</span>
                <span className="text-[#E4E8DF]/50">/g</span>
              </span>
            ))}
            {updatedAt && (
              <span className="hidden md:inline text-[#E4E8DF]/40 whitespace-nowrap">· Updated {formatTime(updatedAt)}</span>
            )}
          </div>
        ) : (
          <div className="flex items-center gap-2 text-[#E4E8DF]/60">
            <span className="w-1.5 h-1.5 rounded-full bg-[#7A8A73] animate-pulse"></span>
            Fetching today's gold rate…
          </div>
        )}

        {/* Right: Promo */}
        <div className="hidden lg:flex items-center gap-4 text-[#E4E8DF]/70 whitespace-nowrap flex-shrink-0">
          <span className="flex items-center gap-1.5"><Truck size={11} /> Free shipping across India</span>
          <span className="flex items-center gap-1.5"><Sparkles size={11} /> BIS Hallmark Certified</span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
